import type { ReactNode } from 'react';

// Un riquadro delle Impostazioni, come in SurgeAI (tela, artboard 47): etichetta in maiuscoletto,
// titolo e descrizione a sinistra, il controllo a destra, e sotto quello che serve in più.
export function SettingsBlock({
  over,
  title,
  hint,
  control,
  children,
}: {
  over: string;
  title: string;
  hint?: ReactNode;
  control?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <section className="settings-box">
      <div className="settings-block">
        <div className="settings-block-text">
          <span className="t-overline faint">{over}</span>
          <h3 className="t-strong" style={{ margin: 0 }}>
            {title}
          </h3>
          {hint && <span className="t-caption dim">{hint}</span>}
        </div>
        {control}
      </div>
      {children && <div style={{ marginTop: 14 }}>{children}</div>}
    </section>
  );
}
